module.exports = __webpack_public_path__ + "img/logo2.62edbb30.png";